/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TranslationDraft
 */
export interface TranslationDraft {
    /**
     * 
     * @type {string}
     * @memberof TranslationDraft
     */
    language_code: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationDraft
     */
    language_name: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationDraft
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationDraft
     */
    error?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TranslationDraft
     */
    header?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TranslationDraft
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TranslationDraft
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TranslationDraft
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TranslationDraft
     */
    link_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TranslationDraft
     */
    section_type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TranslationDraft
     */
    is_active?: boolean | null;
}

/**
 * Check if a given object implements the TranslationDraft interface.
 */
export function instanceOfTranslationDraft(value: object): value is TranslationDraft {
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    if (!('language_name' in value) || value['language_name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function TranslationDraftFromJSON(json: any): TranslationDraft {
    return TranslationDraftFromJSONTyped(json, false);
}

export function TranslationDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranslationDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'language_code': json['language_code'],
        'language_name': json['language_name'],
        'status': json['status'],
        'error': json['error'] == null ? undefined : json['error'],
        'header': json['header'] == null ? undefined : json['header'],
        'message': json['message'] == null ? undefined : json['message'],
        'name': json['name'] == null ? undefined : json['name'],
        'url': json['url'] == null ? undefined : json['url'],
        'link_type': json['link_type'] == null ? undefined : json['link_type'],
        'section_type': json['section_type'] == null ? undefined : json['section_type'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
    };
}

export function TranslationDraftToJSON(json: any): TranslationDraft {
    return TranslationDraftToJSONTyped(json, false);
}

export function TranslationDraftToJSONTyped(value?: TranslationDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'language_code': value['language_code'],
        'language_name': value['language_name'],
        'status': value['status'],
        'error': value['error'],
        'header': value['header'],
        'message': value['message'],
        'name': value['name'],
        'url': value['url'],
        'link_type': value['link_type'],
        'section_type': value['section_type'],
        'is_active': value['is_active'],
    };
}

